import React, { FC, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { CouponItem, CouponDetail, MktEmpty, Header } from '@cps'
import { memberMobx } from '@mobxStore'
import MemberApi from 'api/member.api'
import { modalLayer, useHistoryNew } from '@utils'
import i18n from 'i18next'
import './index.scss'

import noCouponImg from '@img/no-coupon.png'

interface IProps extends IPage, RouteComponentProps { }

const CouponRecordPage: FC<IProps> = () => {
  const contentRef = useRef<any>(null)
  const selectArr: any[] = [
    {
      label: i18n.t('mkt.coupon.used'),
      value: 'use',
    },
    {
      label: i18n.t('mkt.coupon.expired'),
      value: 'expired',
    },
    {
      label: i18n.t('mkt.giftCard.status_stopUsing'),
      value: 'disable',
    }
  ]
  const history = useHistoryNew()
  const { couponListForDisable } = memberMobx
  const [log, setLog] = useState<any[]>([])
  const [type, setType] = useState<string>(selectArr[0].value)
  // Componeent Event
  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'use', couponInfo: data }, 'couponDetail')
  }
  const changeRecord = (value: string) => {
    contentRef.current.scrollToTop()
    setType(value)
    if (value === 'disable') {
      setLog(couponListForDisable)
    } else {
      const para: any = {}
      if (value === 'use') {
        para.isUsed = 1
      } else if (value === 'expired') {
        para.isExpire = 1
      }
      MemberApi.getMemberCoupons(para).then((res: any) => {
        if (!res.error) {
          setLog(res)
        } else {
          setLog([])
        }
      })
    }
  }
  // Component Effect
  useIonViewWillEnter(() => {
    changeRecord(type)
  })
  return (
    <IonPage className='coupon-record-page'>
      <Header onBack={() => history.goBack()}>
        {
          selectArr.map((item: any) => (
            <div data-cypid='mmgClickCouponRecordType' className={`top-select ${type === item.value ? 'title' : 'desc'}`} key={item.value} onClick={() => { changeRecord(item.value) }}>
              <span>{item.label}</span>
            </div>))
        }
      </Header>
      <IonContent className='page-content' ref={contentRef}>
        {
          log.length > 0 ? (
            <div className='page-body'>
              {
                log.map((item: any, index: number) => {
                  return (
                    <div className='coupon-block' key={index}>
                      <CouponItem type='use' used={type === 'use'} expired={type === 'expired' && item.status === 'enable'} couponInfo={item} onDetail={() => goDetail(item)}></CouponItem>
                    </div>
                  )
                })
              }
            </div>) : <MktEmpty img={noCouponImg}></MktEmpty>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponRecordPage)
